import React, { useContext } from 'react';
import TextField from '@material-ui/core/TextField';
import { store } from './reducer';
import checkMobilePhone from '../../../fns/checkMobilePhone';
import normalizeMobilePhone from '../../../fns/normalizeMobile';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

const Filters = () => {
  const {
    state: {
      search: {
        firstName,
        lastName,
        nationalCode,
        mobilePhone,
        company,
        companyNationalCode,
        role,
      },
    },
    dispatch,
  } = useContext(store);

  const handleChangeTF = (e) => {
    let { name, value } = e.target;
    name === 'mobilePhone' && (value = checkMobilePhone(value) || value);
    dispatch({ type: 'CHANGE_SEARCH_TEXT_FIELD', payload: { name, value } });
  };
  const handleChangeCheckbox = (e) => {
    let { name, checked } = e.target;
    if (checked) {
      dispatch({ type: 'CHANGE_ROLE', payload: [...role, name] });
    } else {
      const _role = role.filter((r) => r !== name);
      dispatch({ type: 'CHANGE_ROLE', payload: _role });
    }
  };

  return (
    <>
      <TextField
        label="نام"
        name="firstName"
        fullWidth
        variant="outlined"
        size="small"
        value={firstName || ''}
        onChange={handleChangeTF}
      />
      <TextField
        label="نام خانوادگی"
        name="lastName"
        fullWidth
        variant="outlined"
        size="small"
        value={lastName || ''}
        onChange={handleChangeTF}
      />
      <TextField
        value={nationalCode || ''}
        name="nationalCode"
        label="کد ملی"
        fullWidth
        variant="outlined"
        size="small"
        onChange={handleChangeTF}
        type="number"
      />
      <TextField
        value={mobilePhone ? normalizeMobilePhone(mobilePhone) : ''}
        name="mobilePhone"
        label="موبایل"
        fullWidth
        variant="outlined"
        size="small"
        onChange={handleChangeTF}
        style={{ direction: 'ltr' }}
      />
      <TextField
        value={company || ''}
        name="company"
        label="نام شرکت"
        fullWidth
        variant="outlined"
        size="small"
        onChange={handleChangeTF}
      />
      <TextField
        value={companyNationalCode || ''}
        name="companyNationalCode"
        label="شناسه ملی"
        fullWidth
        variant="outlined"
        size="small"
        onChange={handleChangeTF}
        type="number"
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={role?.includes('customer') ? true : false}
            onChange={handleChangeCheckbox}
            name="customer"
          />
        }
        label="صاحبین بار"
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={role?.includes('driver') ? true : false}
            onChange={handleChangeCheckbox}
            name="driver"
          />
        }
        label="رانندگان"
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={role?.includes('admin') ? true : false}
            onChange={handleChangeCheckbox}
            name="admin"
          />
        }
        label="کارشناسان حمل"
      />
    </>
  );
};

export default React.memo(Filters);
